import axios from "axios";

const client = axios.create({ baseURL: process.env.REACT_APP_API_URL });

client.interceptors.request.use(
  (config) => {
    const authData = JSON.parse(localStorage.getItem("authData") || "null");
    if (authData?.accessToken) {
      config.headers.Authorization = `Bearer ${authData.accessToken}`;
    }
    return config;
  },
  (error) => Promise.reject(error)
);

export default client;
